import { X } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import styles from './PanelHeader.module.scss';

interface PanelHeaderProps {
  onClose: () => void;
  title?: string;
}

export const PanelHeader = ({ onClose, title }: PanelHeaderProps) => {
  return (
    <div className={styles.mobileBackButtonRow}>
      <button
        type="button"
        onClick={onClose}
        className={styles.mobileBackButton}
      >
        <span>{title || 'Checkout'}</span>
        <X size={SVG_SIZE_M} />
      </button>
    </div>
  );
};
